import { Avatar, Box, Button, Dialog, DialogActions, Grid, IconButton } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";
import { useSelector } from "react-redux";
import { IState } from "store/types";

interface IProps {
  open: boolean;
  hasUnsortedContent: boolean;
  onConfirm: () => any;
  onClose: () => any;
}

const style = {
  height: "175px",
  width: "530px",
  bgcolor: "#FFFFFF",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "8px",
  p: 4,
};

const PageTitle = styled.legend`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
`;

export const SubmitConfirmationDialog = ({ open, hasUnsortedContent, onConfirm, onClose }: IProps) => {
  // What we need from Redux
  const submittingChanges = useSelector((state: IState) => state.submittingChanges);

  const titleGridItemWidth = hasUnsortedContent ? 10 : 11;
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="confirm-dialog">
      <Box sx={style}>
        <>
          <Grid container spacing={1} alignItems="center">
            {hasUnsortedContent && (
              <Grid item xs={1}>
                {
                  <Avatar sx={{ backgroundColor: "#FEF1F2" }}>
                    <ErrorOutlineIcon sx={{ color: "#881113" }} />
                  </Avatar>
                }
              </Grid>
            )}
            <Grid item xs={titleGridItemWidth} style={{ display: "flex", alignItems: "center" }}>
              <PageTitle>{hasUnsortedContent ? "Content within 'Unsorted'" : "Save changes"}</PageTitle>
            </Grid>
            <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  color: "#414141",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          {hasUnsortedContent && (
            <p>
              There is content remaining within the unsorted section. If you update the site,{" "}
              <strong>any unsorted content will be excluded</strong>.
            </p>
          )}
          {hasUnsortedContent || <p>Please confirm you want to apply these changes to your site.</p>}
          <DialogActions sx={{ paddingRight: "0px", paddingTop: "24px", paddingBottom: "16px" }}>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={onConfirm} disabled={submittingChanges}>
              {hasUnsortedContent ? "Exclude and update site" : "Update site"}
            </Button>
          </DialogActions>
        </>
      </Box>
    </Dialog>
  );
};
